import { useState } from "react"
import { Alert, Stack } from "@mui/material"
import { useField } from "formik"

import { useAppLocalization } from "../../../../../../modules/localization/components/AppLocalizationProvider"
import { toDinero } from "../../../../../../modules/currency/currencyLib"
import { useMoney } from "../../../../../../modules/currency/useMoney"
import { ProductWithQuantity } from "../../../createOrderTypes"
import { useCreateOrderDialogType } from "../../../hooks/useCreateOrderDialogType"
import { DeliveryTimesField, DynamicConfigKey } from "../../form/formTypes"

export function AutoAddedServicesNotifications() {
    const { isRefundOrder } = useCreateOrderDialogType()
    const { l10n } = useAppLocalization()
    const moneyFactory = useMoney({})
    const [{ value: deliveries }] = useField<DeliveryTimesField | undefined>(DynamicConfigKey.MULTIPLE_DELIVERIES)
    const [dismissed, setDismissed] = useState<Set<number>>(new Set())

    if (isRefundOrder || !deliveries?.deliveryTimes) return null

    const seen = new Set<number>()
    const messages: Array<{ id: number; message: string }> = []

    for (const dt of deliveries.deliveryTimes) {
        for (const line of dt.orderLines) {
            const pw = line as ProductWithQuantity
            if (pw.isAutoAddedExtraService && typeof pw.id === "number" && !seen.has(pw.id) && !dismissed.has(pw.id)) {
                seen.add(pw.id)
                const amount = moneyFactory.format(toDinero(pw.price))
                const message = l10n.getString("create-order-extra-services-auto-added-snackbar", {
                    amount,
                    name: pw.name,
                })
                messages.push({ id: pw.id, message })
            }
        }
    }

    if (!messages.length) return null

    const handleClose = (id: number) => setDismissed((prev) => new Set(prev).add(id))

    return (
        <Stack gap="0.5rem">
            {messages.map(({ id, message }) => (
                <Alert key={id} severity="error" onClose={() => handleClose(id)}>
                    {message}
                </Alert>
            ))}
        </Stack>
    )
}
